<ix-modal-header
  [title]="'Storage Settings' | translate"
  [loading]="isFormLoading"
></ix-modal-header>
<mat-card>
  <mat-card-content>
    <form class="ix-form-container" [formGroup]="form" (submit)="onSubmit()">
      <ix-fieldset>
        <ix-select
          formControlName="pool"
          [label]="'Select Pool' | translate"
          [required]="true"
          [options]="poolOptions$"
        ></ix-select>
        <ix-input
          formControlName="swapondrive"
          [label]="'Swap Size' | translate"
          [required]="true"
          [hint]="'Value in GiB' | translate "
          [tooltip]="'By default, all data disks are created with the amount of swap specified. Changing the value does not affect the amount of swap on existing disks, only disks added after the change. Does not affect log or cache devices as they are created without swap.' | translate"
        ></ix-input>
      </ix-fieldset>

      <ix-form-actions>
        <button
          mat-button
          type="submit"
          color="primary"
          ixTest="save"
          [disabled]="form.invalid || isFormLoading"
        >
          {{ 'Save' | translate }}
        </button>
      </ix-form-actions>
    </form>
  </mat-card-content>
</mat-card>
